import { lazy } from "react";
// Executive Financial Dashboard Module (Module K — BillingV2 Stage 2)
// MLR vs target, deficit drivers and module-level revenue impact.

const ExecutiveFinancialPage = lazy(() => import("./pages/ExecutiveFinancialPage"));
// Export routes for AppRouter
export const executiveFinancialRoutes = [
  {
    path: "/executive-financial",
    element: <ExecutiveFinancialPage />,
  },
];

// Export components for external use
